import React, { useState } from 'react';
import axios from '../../axiosConfig';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../../styles/RegisterInvitedTrainer.css';

const RegisterInvitedTrainer = () => {
    const [formData, setFormData] = useState({
        password: '',
        firstName: '',
        lastName: '',
        phone: '',
        country: '',
        city: '',
        postalCode: '',
        street: '',
        buildingNumber: '',
        apartmentNumber: '',
        statuteAccepted: false
    });

    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [fieldErrors, setFieldErrors] = useState({});
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const handleChange = (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setFormData({ ...formData, [e.target.name]: value });
        // Clear field error when user starts typing
        if (fieldErrors[e.target.name]) {
            setFieldErrors({ ...fieldErrors, [e.target.name]: '' });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setFieldErrors({});

        if (!token) {
            setError('Nieprawidłowy lub brakujący token rejestracyjny.');
            return;
        }

        const requestBody = {
            password: formData.password,
            firstName: formData.firstName,
            lastName: formData.lastName,
            phone: formData.phone,
            statuteAccepted: formData.statuteAccepted,
            address: {
                country: formData.country,
                city: formData.city,
                postalCode: formData.postalCode,
                street: formData.street,
                buildingNumber: formData.buildingNumber,
                apartmentNumber: formData.apartmentNumber
            }
        };

        try {
            await axios.post(`/api/v1/auth/registerToExistingSchool/trainer?token=${token}`, requestBody);
            setSuccess('Trener zarejestrowany pomyślnie! Przekierowywanie...');
            setTimeout(() => navigate('/'), 2000);
        } catch (err) {
            console.error('Registration error:', err);
            if (err.response?.data?.errors) {
                // Handle field-specific validation errors
                const errors = err.response.data.errors;
                const mappedErrors = {};

                // Map backend field names to form field names
                Object.keys(errors).forEach(key => {
                    if (key.startsWith('address.')) {
                        // Handle nested address fields (e.g., address.city -> city)
                        const fieldName = key.replace('address.', '');
                        mappedErrors[fieldName] = errors[key];
                    } else {
                        mappedErrors[key] = errors[key];
                    }
                });

                setFieldErrors(mappedErrors);
                setError(err.response.data.message || 'Błąd walidacji');
            } else {
                setError('Rejestracja nie powiodła się. Proszę sprawdzić wprowadzone dane.');
            }
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    if (!token) {
        return (
            <div className="register-invited-trainer-container">
                <div className="register-invited-trainer-left-panel">
                    <div className="register-invited-trainer-left-content">
                        <h2>
                            Dołącz do
                            <span className="highlight">naszego zespołu</span>
                        </h2>
                    </div>
                </div>
                <div className="register-invited-trainer-right-panel">
                    <div className="register-invited-trainer-form-container">
                        <h1>Error</h1>
                        <p className="register-invited-trainer-error">Nieprawidłowy lub brakujący token rejestracyjny.</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="register-invited-trainer-container">
            <div className="register-invited-trainer-left-panel">
                <div className="register-invited-trainer-left-content">
                    <h2>
                        Dołącz do
                        <span className="highlight">naszego zespołu</span>
                    </h2>
                </div>
            </div>
            <div className="register-invited-trainer-right-panel">
                <button className="register-invited-trainer-back-button" onClick={handleBack}>
                    ← wróć
                </button>
                <div className="register-invited-trainer-form-container">
                    <h1>Zarejestruj się jako trener</h1>
                    <form onSubmit={handleSubmit} className="register-invited-trainer-form">
                        <div className="register-invited-trainer-form-group full-width">
                            <input
                                type="password"
                                name="password"
                                placeholder="Hasło"
                                value={formData.password}
                                required
                                onChange={handleChange}
                                className={fieldErrors.password ? 'input-error' : ''}
                            />
                            {fieldErrors.password && <span className="field-error">{fieldErrors.password}</span>}
                        </div>

                        <div className="register-invited-trainer-form-row">
                            <div className="register-invited-trainer-form-group">
                                <input
                                    type="text"
                                    name="firstName"
                                    placeholder="Imię"
                                    value={formData.firstName}
                                    required
                                    onChange={handleChange}
                                    className={fieldErrors.firstName ? 'input-error' : ''}
                                />
                                {fieldErrors.firstName && <span className="field-error">{fieldErrors.firstName}</span>}
                            </div>
                            <div className="register-invited-trainer-form-group">
                                <input
                                    type="text"
                                    name="lastName"
                                    placeholder="Nazwisko"
                                    value={formData.lastName}
                                    required
                                    onChange={handleChange}
                                    className={fieldErrors.lastName ? 'input-error' : ''}
                                />
                                {fieldErrors.lastName && <span className="field-error">{fieldErrors.lastName}</span>}
                            </div>
                        </div>

                        <div className="register-invited-trainer-form-group full-width">
                            <input
                                type="text"
                                name="phone"
                                placeholder="Numer telefonu"
                                value={formData.phone}
                                required
                                onChange={handleChange}
                                className={fieldErrors.phone ? 'input-error' : ''}
                            />
                            {fieldErrors.phone && <span className="field-error">{fieldErrors.phone}</span>}
                        </div>

                        <h2>Adres</h2>

                        <div className="register-invited-trainer-form-row">
                            <div className="register-invited-trainer-form-group">
                                <input
                                    type="text"
                                    name="country"
                                    placeholder="Kraj"
                                    value={formData.country}
                                    required
                                    onChange={handleChange}
                                    className={fieldErrors.country ? 'input-error' : ''}
                                />
                                {fieldErrors.country && <span className="field-error">{fieldErrors.country}</span>}
                            </div>
                            <div className="register-invited-trainer-form-group">
                                <input
                                    type="text"
                                    name="city"
                                    placeholder="Miasto"
                                    value={formData.city}
                                    required
                                    onChange={handleChange}
                                    className={fieldErrors.city ? 'input-error' : ''}
                                />
                                {fieldErrors.city && <span className="field-error">{fieldErrors.city}</span>}
                            </div>
                        </div>

                        <div className="register-invited-trainer-form-row">
                            <div className="register-invited-trainer-form-group">
                                <input
                                    type="text"
                                    name="postalCode"
                                    placeholder="Kod pocztowy"
                                    value={formData.postalCode}
                                    required
                                    onChange={handleChange}
                                    className={fieldErrors.postalCode ? 'input-error' : ''}
                                />
                                {fieldErrors.postalCode && <span className="field-error">{fieldErrors.postalCode}</span>}
                            </div>
                            <div className="register-invited-trainer-form-group">
                                <input
                                    type="text"
                                    name="street"
                                    placeholder="Ulica"
                                    value={formData.street}
                                    required
                                    onChange={handleChange}
                                    className={fieldErrors.street ? 'input-error' : ''}
                                />
                                {fieldErrors.street && <span className="field-error">{fieldErrors.street}</span>}
                            </div>
                        </div>

                        <div className="register-invited-trainer-form-row">
                            <div className="register-invited-trainer-form-group">
                                <input
                                    type="text"
                                    name="buildingNumber"
                                    placeholder="Numer budynku"
                                    value={formData.buildingNumber}
                                    required
                                    onChange={handleChange}
                                    className={fieldErrors.buildingNumber ? 'input-error' : ''}
                                />
                                {fieldErrors.buildingNumber && <span className="field-error">{fieldErrors.buildingNumber}</span>}
                            </div>
                            <div className="register-invited-trainer-form-group">
                                <input
                                    type="text"
                                    name="apartmentNumber"
                                    placeholder="Numer mieszkania (opcjonalne)"
                                    value={formData.apartmentNumber}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="register-invited-trainer-checkbox-group">
                            <label className="register-invited-trainer-checkbox-label">
                                <input
                                    type="checkbox"
                                    name="statuteAccepted"
                                    checked={formData.statuteAccepted}
                                    onChange={handleChange}
                                    required
                                    className="register-invited-trainer-checkbox"
                                />
                                <span>Akceptuję <a href="https://petboard.pl/regulamin/" target="_blank" rel="noopener noreferrer">regulamin aplikacji</a></span>
                            </label>
                            {fieldErrors.statuteAccepted && <span className="field-error">{fieldErrors.statuteAccepted}</span>}
                        </div>

                        {error && <p className="register-invited-trainer-error">{error}</p>}
                        {success && <p className="register-invited-trainer-success">{success}</p>}

                        <button type="submit" className="register-invited-trainer-submit-btn">
                            Zarejestruj się
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default RegisterInvitedTrainer;